import './collectivework.css'
import bookStackImg from '../../../../assets/img/libro/libro_img.png'

const CollectiveWork = () => {
  return (
    <section className='collectiveWork'>

      <div className='collectiveWork__container section__padding'>

        {/* COLUMNA IZQUIERDA */}
        <div className='collectiveWork__left'>
          <h2 className='collectiveWork__mainTitle'>
            La educadora menstrual: un nuevo campo educativo y político
          </h2>

          <p>
            Por primera vez, este libro traza una visión integral, situada y colectiva de la educadora menstrual.
          </p>

          <p>
            Aborda sus roles, funciones, objetivos y ética, ofreciendo criterios claros y fundamentados para la práctica educativa en escuelas, comunidades, lugares de trabajo y otros ámbitos de intervención.
          </p>

        </div>

        {/* COLUMNA DERECHA */}
        <div className='collectiveWork__right'>
          

          <div className='collectiveWork__image'>
            <img src={bookStackImg} alt='Libros Educación Menstrual' />
          </div>
          
          <h3 className='collectiveWork__sideTitle'>
            Una obra colectiva, feminista e internacional
          </h3>

          <p>
            Pensada, redactada, revisada y cuidada por catorce autoras, esta obra se construyó a través de un proceso interoceánico sostenido en el tiempo, que exigió coordinación, rigor y un profundo trabajo colectivo. 
          </p>

          <p>
            De ahí que sea una obra colectiva pionera: un recurso necesario y transformador por su enfoque político de la educación menstrual y por su carácter feminista e internacional, capaz de articular saberes de la educación comunitaria, el activismo, la investigación académica y las prácticas territoriales.
          </p>
        </div>

      </div>

    </section>
  )
}

export default CollectiveWork
